/* globals google */
'use strict';

var base = require('base/storeLocator/storeLocator');
var shippingHelpers = require('../checkout/shipping');

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}
/**
 * Uses google maps api to render a map
 */
function maps() {
    var map;
    var infowindow = new google.maps.InfoWindow();

    // Init U.S. Map in the center of the viewport
    var latlng = new google.maps.LatLng(-34.604713, -58.434290);
    var mapOptions = {
        scrollwheel: false,
        zoom: 10,
        center: latlng
    };

    map = new google.maps.Map($('#map-canvas-correo-arg')[0], mapOptions);
    var mapdiv = $('#map-canvas-correo-arg').attr('data-locations');

    mapdiv = JSON.parse(mapdiv);
    var bounds = new google.maps.LatLngBounds();

    // Customized google map marker icon with svg format
    var markerImg = {
        path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z',
        fillColor: '#e60c19',
        fillOpacity: 1,
        scale: 1,
        strokeColor: 'white',
        strokeWeight: 0.8,
        anchor: new google.maps.Point(0, 0),
        labelOrigin: new google.maps.Point(0, -30)
    };

    // var mapdivKeys = Object.keys(mapdiv).splice(0, 5);
    var mapdivKeys = Object.keys(mapdiv);
    var filteredForVisualRenderInMap = false;

    mapdivKeys.forEach(function (key, index) {
        var item = mapdiv[key];
        if (item.filteredForVisualRenderInMap) {
            filteredForVisualRenderInMap = true;
        }
    });

    mapdivKeys.forEach(function (key, index) {
        var item = mapdiv[key];
        var label = parseInt(key, 10) + 1;
        var storeLocation = new google.maps.LatLng(
            item.latitude,
            item.longitude
        );
        var marker = new google.maps.Marker({
            position: storeLocation,
            map: map,
            title: item.name,
            icon: markerImg,
            label: {
                text: label.toString(),
                color: 'white',
                fontSize: '12px'
            }
        });
        marker.addListener('click', function () {
            infowindow.setOptions({
                content: item.infoWindowHtml
            });
            infowindow.open(map, marker);
            let selectRadioButton = $(`#input-${item.storeId}-carg`);
            let selectStoreButton = $('.select-store-correo-arg');
            var resultsContainer = selectRadioButton.closest('.results-correo-arg');
            $('input[name="store"]').attr('checked', false);
            var cardBodyContainer = selectRadioButton.closest('.form-check');
            var scrollTo = cardBodyContainer.position().top + resultsContainer.scrollTop();
            resultsContainer.animate({
                scrollTop: scrollTo
            }, 300);
            selectStoreButton.attr('disabled', false);
            selectRadioButton.attr('checked', true);
        });

        // Create a minimum bound based on a set of storeLocations
        //  This bounding box can be used to ensure that all specified points are visible within a map's viewport. .
        // Each marker is included in the bound, so all are going to be displayed
        if (!filteredForVisualRenderInMap) {
            bounds.extend(marker.position);
        } else if (item.filteredForVisualRenderInMap) {
            bounds.extend(marker.position);
        }
    });
    // Fit the all the store marks in the center of a minimum bounds when any store has been found.
    if (mapdiv && mapdiv.length !== 0) {
        map.fitBounds(bounds);
    }
}

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */

function updateStoresResults(data) {
    var $resultsDiv = $('.results-correo-arg');
    var $mapDiv = $('#map-canvas-correo-arg');
    if (data.stores) {
        var hasResults = data.stores.length > 0;
        if (!hasResults) {
            $('.store-locator-no-results-correo-arg').removeClass('d-none');
        } else {
            $('.store-locator-no-results-correo-arg').addClass('d-none');
        }
        $resultsDiv
            .empty()
            .data('has-results', hasResults)
            .data('radius', data.radius)
            .data('search-key', data.searchKey);

        $mapDiv.attr('data-locations', data.locations);

        if ($mapDiv.data('has-google-api')) {
            maps();
        } else {
            $('.store-locator-no-apiKey').show();
        }

        if (data.storesResultsHtml) {
            $resultsDiv.append(data.storesResultsHtml);
            // $('.store-map-link').on('click', function () {
            //     var clickStoreNameGtm = {
            //         event: 'trackEvent',
            //         eventCategory: 'cta',
            //         eventAction: 'click en link de sucursal',
            //         eventLabel: $(this).prop('innerText')
            //     };
            //     window.dataLayer = window.dataLayer || [];
            //     window.dataLayer.push(clickStoreNameGtm);
            // });
            // $('.storelocator-phone').on('click', function () {
            //     var clickStoreNameGtm = {
            //         event: 'trackEvent',
            //         eventCategory: 'cta',
            //         eventAction: 'click en teléfono de sucursal',
            //         eventLabel: $(this).prop('innerText')
            //     };
            //     window.dataLayer = window.dataLayer || [];
            //     window.dataLayer.push(clickStoreNameGtm);
            // });
        }
    } else {
        $('.store-locator-no-results-correo-arg').removeClass('d-none');
        $resultsDiv.addClass('d-none');
    }
}

function search(element) {
    var $storeLocatorModal = element.closest('.modal');
    var dialog = element.closest('.in-store-inventory-dialog');
    var spinner = dialog.length ? dialog.spinner() : $.spinner();
    spinner.start();
    $storeLocatorModal.spinner().start();
    var $form = element.closest('.store-locator');
    var radius = $('.results-correo-arg').data('radius');
    var url = $form.attr('action');
    var urlParams = {
        radius: radius
    };


    var shipmentUUID = $storeLocatorModal.attr('shipmentuuid');
    var stateIdSelect = $('#stateIdSelect');
    var payload = {
        postalCode: $form.find('[name="postalCode"]').val(),
        shipmentUUID: shipmentUUID,
        stateId: stateIdSelect.val()
    };

    url = appendToUrl(url, urlParams);

    /**
     * DAB-4756  BEGIN Find store with postal code Google Tag Manager
     */
    // var storesGtmEvent = {
    //     event: 'trackEvent',
    //     eventCategory: 'cta',
    //     eventAction: 'buscador codigo postal',
    //     eventLabel: $form.find('[name="postalCode"]').val()
    // };
    // if (storesGtmEvent.eventLabel !== null && storesGtmEvent.eventLabel !== '') {
    //     window.dataLayer = window.dataLayer || [];
    //     window.dataLayer.push(storesGtmEvent);
    // }
    /**
     * DAB-4756  END
     */
    $.ajax({
        url: url,
        type: $form.attr('method'),
        data: payload,
        dataType: 'json',
        success: function (response) {
            $storeLocatorModal.spinner().stop();
            spinner.stop();
            if (response.error) {
                console.error(response.data);
            } else {
                updateStoresResults(response.data);
                $('.select-store').prop('disabled', true);
                var isCheckout = $('[name="ischeckout"]').length > 0;
                if (isCheckout) {
                    $('.select-store-input-correo-arg').show();
                    $('.store-details-correo-arg .result-number').hide();
                }
            }
        },
        error: function (e) {
            $storeLocatorModal.spinner().stop();
            $.spinner().stop();
            console.error('Error in correo argentino services', e.responseJSON.error.errorText);
        }
    });
    return false;
}

base.init = function () {
    $('body').on('store:selected', function (e, data) {
        var storeLocatorModal = $('#correoArgLocatorModal');
        var isMulti = storeLocatorModal.attr('ismulti');
        var form;
        if (isMulti) {
            var pliUUIDInput = $('[value=' + storeLocatorModal.attr('productlineitemuuid') + ']');
            form = pliUUIDInput[0].form;
        } else {
            var shipmentSelectorDefualt = $('#shipmentSelector-default');
            form = (shipmentSelectorDefualt.length !== 0) ? shipmentSelectorDefualt[0].form : null;
        }
        if (form) {
            var fieldSet = $('.pickup-in-store', form);
            var storeIdInput = fieldSet.find('[name="storeId"]');
            var newLabel = $(data.storeDetailsHtml);
            var storeAddressNumber;
            if (data.storeInfo.custom && data.storeInfo.custom.number) {
                storeAddressNumber = data.storeInfo.custom.number;
            } else {
                storeAddressNumber = data.storeInfo.stateCode;
            }
            $('.selected-store', form).find('.store-name').empty().append(data.storeInfo.name);
            $('.selected-store', form).find('.store-map').empty().append(data.storeInfo.address1 + ' ' + storeAddressNumber);
            $('.selected-store', form).find('.storelocator-phone').empty().append(data.storeInfo.phone);
            $('.selected-store', form).show();
            storeIdInput.val(data.storeID);
        }
    });
    if ($('.open-locator-correo-arg')) {
        $('.open-locator-correo-arg').on('click', function (e) {
            if ($('#stateIdSelect').val() === null) {
                $('.invalid-feedback-sp').text('Debes de seleccionar una provincia.');
                e.stopPropagation();
                return;
            }
            $('.invalid-feedback-sp').text('');
            e.preventDefault();
            var postalCodeInput = $('#storeCorreoArg');
            var storeLocatorModal = $('#correoArgLocatorModal');
            var modalPostalCodeInput = storeLocatorModal.find('#store-postal-code');
            var modalSearchButton = storeLocatorModal.parent().find('.btn-storelocator-search-correo-arg');
            var shipmentUUID = postalCodeInput.closest('.shipping-form').find('[name="shipmentUUID"]').val();
            if (postalCodeInput.closest('.shipping-form').find('[name="productLineItemUUID"]').length > 0) {
                var pliUUID = postalCodeInput.closest('.shipping-form').find('[name="productLineItemUUID"]').val();
                storeLocatorModal.attr('productLineItemUUID', pliUUID);
                storeLocatorModal.attr('isMulti', true);
            }
            var originalShipmentUUID = postalCodeInput.closest('.shipping-form').find('[name="originalShipmentUUID"]').val();
            modalPostalCodeInput.val(postalCodeInput.val());
            storeLocatorModal.attr('shipmentUUID', shipmentUUID);
            storeLocatorModal.attr('originalShipmentUUID', originalShipmentUUID);
            search(modalSearchButton);
        });
    }
    if ($('#map-canvas-correo-arg').data('has-google-api')) {
        maps();
    } else {
        $('.store-locator-no-apiKey').show();
    }

    if (!$('.results-correo-arg').data('has-results')) {
        $('.store-locator-no-results-correo-arg').show();
    }
};

base.selectStore = function () {
    $('.store-locator-container-correo-arg').on('click', '.select-store-correo-arg', (function (e) {
        e.preventDefault();
        var selectedStore = $(':checked', '.results-card-correo-arg .results-correo-arg');
        var data = {
            storeID: selectedStore.val(),
            searchRadius: $('#radius').val(),
            searchPostalCode: $('.results-correo-arg').data('search-key').postalCode,
            storeDetailsHtml: selectedStore.siblings('label').find('.store-details').html(),
            storeInfo: JSON.parse(selectedStore.attr('data-store-info')),
            event: e
        };
        $('#correoArgentinoAgenciesObject').val(JSON.stringify(data));
        /**
         * DAB-4756 BEGIN - push datalayer Select store event Google Tag manager
         */
        // var storeSelectedGtmEvent = {
        //     event: 'trackEvent',
        //     eventCategory: 'cta',
        //     eventAction: `sucursal: ${JSON.parse(selectedStore.attr('data-store-info')).name}`,
        //     eventLabel: `Id de sucursal: ${selectedStore.val()}`
        // };
        // if (selectedStore.attr('data-store-info') !== null && selectedStore.attr('data-store-info') !== '') {
        //     window.dataLayer = window.dataLayer || [];
        //     window.dataLayer.push(storeSelectedGtmEvent);
        // }

        /**
         * DAB-4756 END
         */
        $('button.submit-shipping').attr('disabled', false);
        $('body').trigger('store:selected', data);
    }));
};

/*
DAB- 5568
Future functionality for Correo Argentino
*/
// base.detectLocation = function () {
//     // clicking on detect location.
//     $('.detect-location-correo-arg').on('click', function () {
//         $.spinner().start();
//         if (!navigator.geolocation) {
//             $.spinner().stop();
//             return;
//         }
//         var detectLocationGtm = {
//             event: 'trackEvent',
//             eventCategory: 'cta',
//             eventAction: 'usar mi ubicación',
//             eventLabel: $(this).attr('class')
//         };
//         window.dataLayer = window.dataLayer || [];
//         window.dataLayer.push(detectLocationGtm);
//         navigator.geolocation.getCurrentPosition(function (position) {
//             var $detectLocationButton = $('.detect-location-correo-arg');
//             var url = $detectLocationButton.data('action');
//             var radius = $('.results-correo-arg').data('radius');
//             var shipmentUUID = $('#correoArgLocatorModal').attr('shipmentuuid');

//             var urlParams = {
//                 radius: radius,
//                 lat: position.coords.latitude,
//                 long: position.coords.longitude,
//                 shipmentUUID: shipmentUUID
//             };

//             url = appendToUrl(url, urlParams);
//             $.ajax({
//                 url: url,
//                 type: 'get',
//                 dataType: 'json',
//                 success: function (data) {
//                     $.spinner().stop();
//                     updateStoresResults(data);
//                     $('.select-store-correo-arg').prop('disabled', true);
//                 }
//             });
//         });
//     });
// };

base.changeRadius = function () {
    $('.store-locator-container-correo-arg .radius').change(function () {
        var radius = $(this).val();
        var searchKeys = $('.results').data('search-key');
        var url = $(this).data('action-url');
        var urlParams = {};

        if (searchKeys.postalCode) {
            urlParams = {
                radius: radius,
                postalCode: searchKeys.postalCode
            };
        } else if (searchKeys.lat && searchKeys.long) {
            urlParams = {
                radius: radius,
                lat: searchKeys.lat,
                long: searchKeys.long
            };
        }

        url = appendToUrl(url, urlParams);
        var dialog = $(this).closest('.in-store-inventory-dialog');
        var spinner = dialog.length ? dialog.spinner() : $.spinner();
        spinner.start();
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                spinner.stop();
                updateStoresResults(data);
                $('.select-store').prop('disabled', true);
            }
        });
    });
};

base.search = function () {
    $('.store-locator-container-correo-arg form.store-locator').submit(function (e) {
        e.preventDefault();
        search($(this));
    });
    $('.store-locator-container-correo-arg .btn-storelocator-search-correo-arg[type="button"]').click(
        function (e) {
            e.preventDefault();
            search($(this));
        }
    );
    var postalCodeInputCorreoArg = $('#storeCorreoArg');
    postalCodeInputCorreoArg.on('keydown', function (e) {
        if (e.code === 'Enter') {
            $('.open-locator-correo-arg').trigger('click');
        }
    });
};

base.updateSelectStoreButton = function () {
    $('body').on('change', '.select-store-input-correo-arg', (function () {
        $('.select-store-correo-arg').prop('disabled', false);
    }));
};

base.removeSelectedstore = function () {
    $('.selected-store-header i.fa-trash').on('click', function (e) {
        var shipping = {
            UUID: ''
        };
        var form = e.target.form;
        var shipmentUUID = $('input[name=shipmentUUID]', form).val();
        var fieldSet = $('.pickup-in-store', form);
        var selectedStoreHtml = $('.selected-store', form);

        shipping.UUID = shipmentUUID;
        shippingHelpers.methods.updateShippingAddressFormValues(shipping);
        fieldSet.find('[name="storeId"]').val('');
        selectedStoreHtml.find('.store-name').empty();
        selectedStoreHtml.find('.store-map').empty();
        selectedStoreHtml.find('.storelocator-phone').empty();
        selectedStoreHtml.hide();
    });
};

module.exports = base;
